import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { HeadersLoggedInWithPackage } from 'web-ui-kit/navigation';
import { primaryM } from 'web-ui-kit/colors';

export default function HeaderMonarch ({
  // Optional Back button configuration.
  // If provided, replaces the Modsy logo with a Back button.
  backButton = {
    enabled: false,
    text: 'Back',
    handleClick: () => {}
  },

  // Modsy button configuration used for routing.
  modsyButtonConfig = {
    destination: '/',
    app: 'web-post-purchase'
  },

  // Number of items currently in cart.
  cartItemCount = 0,

  // To extend styling.
  className = '',

  // One of ['web-post-purchase', 'nextjs', 'wordpress']
  currentApp = 'web-post-purchase',

  // Mechanism for bubbling events up.
  dispatch = () => {},

  // Used to register height and add spacing to UI elements
  headerID = '',

  // Whether the help modal is open
  helpModalOpen = false,

  // To distinguish logged out users viewing shared studios
  isLoggedOutSharedMode = false,

  // Callback fired after click on cart icon.
  onCartClick = () => {},

  // Callback fired after click on help icon.
  onHelpClick = () => {},

  // Customer's projects.
  projects = [],

  // Used to position the drawer menu under the optional top banners.
  topDrawerPosition = '3rem',

  // feature flags
  showHelpMenu = false
}) {
  function LinkComponent ({
    children,
    route = {},
    styledLink
  } = {}) {
    const StyledLink = styledLink;
    if (route.app === 'web-post-purchase') {
      return (
        <ReactRouterLink to={route.destination}>
          <StyledLink>{children}</StyledLink>
        </ReactRouterLink>
      );
    }

    const isZendeskHelpLink = route.destination && (
      (/modsy.zendesk.com/i).test(route.destination) ||
      (/help.modsy.com/i).test(route.destination)
    );

    if (route.app === 'external' && isZendeskHelpLink) {
      return (
        <StyledLink href={route.destination} target='_blank' rel='noopener noreferrer'>
          {children}
        </StyledLink>
      );
    }

    return (
      <StyledLink href={route.destination}>{children}</StyledLink>
    );
  }

  return (
    <HeadersLoggedInWithPackage
      backButton={backButton}
      modsyButtonConfig={modsyButtonConfig}
      cartItemCount={cartItemCount}
      className={className}
      currentApp={currentApp}
      dispatch={dispatch}
      headerID={headerID}
      helpModalOpen={helpModalOpen}
      isLoggedOutSharedMode={isLoggedOutSharedMode}
      linkComponent={LinkComponent}
      onCartClick={onCartClick}
      onHelpClick={onHelpClick}
      projects={projects}
      topDrawerPosition={topDrawerPosition}
      showHelpMenu={showHelpMenu}
    />
  );
}

const ReactRouterLink = styled(Link)`
  text-decoration: none;
  height: 100%;
  color: ${primaryM};
`;
